import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAlquilerById } from 'services/servicioGet';
import { AlquilerBase } from 'utils/models/types';

interface AlquilerState {
  alquiler: AlquilerBase | null;
  loadingAlquiler: boolean;
  errorAlquiler: string | null;
}

// Estado inicial del slice
const initialState: AlquilerState = {
  alquiler: null,
  loadingAlquiler: false,
  errorAlquiler: null,
};

// Thunk para obtener el alquiler
export const fetchAlquilerId = createAsyncThunk<AlquilerBase, number, { rejectValue: string }>(
  'fetchAlquilerId',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getAlquilerById(id.toString());
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de alquiler por Id
const alquilerIdSlice = createSlice({
  name: 'alquiler',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchAlquilerId.pending, state => {
        state.loadingAlquiler = true;
        state.errorAlquiler = null;
      })
      .addCase(fetchAlquilerId.fulfilled, (state, action) => {
        state.alquiler = action.payload;
        state.loadingAlquiler = false;
      })
      .addCase(fetchAlquilerId.rejected, (state, action) => {
        state.loadingAlquiler = false;
        state.errorAlquiler = action.payload as string;
      });
  },
});

export default alquilerIdSlice.reducer;
